module.exports = __webpack_public_path__ + "static/img/Ring-of-day-yellow.61739323.svg";